"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FetchRetryError extends Error {
    constructor(res) {
        super(res.statusText);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FetchRetryError);
        }
        this.res = res;
        this.name = this.constructor.name;
        this.url = res.url;
        this.statusCode = res.status;
    }
}
exports.default = FetchRetryError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2hicC9yZXBvcy9mZXRjaC9zcmMvZmV0Y2gtcmV0cnktZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFxQixlQUFnQixTQUFRLEtBQUs7SUFLakQsWUFBWSxHQUFhO1FBQ3hCLEtBQUssQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDLENBQUM7UUFFdEIsSUFBSSxLQUFLLENBQUMsaUJBQWlCLEVBQUU7WUFDNUIsS0FBSyxDQUFDLGlCQUFpQixDQUFDLElBQUksRUFBRSxlQUFlLENBQUMsQ0FBQztTQUMvQztRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDO1FBQ2YsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQztRQUNsQyxJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQyxHQUFHLENBQUM7UUFDbkIsSUFBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUFDO0lBQzlCLENBQUM7Q0FDRDtBQWpCRCxrQ0FpQkMifQ==